<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.25008 2.75415L2.75806 4.92082M2.75806 4.92082L5.25008 7.25M2.75806 4.92082L11.0763 4.92084M10.7501 13.25L13.243 11.0868M13.243 11.0868L10.7501 8.75004M13.243 11.0868L4.92476 11.0867" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
